(() => {
  let hoverTimer;
  function syncBackdrop() {
    const header = Array.from(document.querySelectorAll('.htl-header-nav')).find(el => el.getBoundingClientRect().height > 0);
    if (header) document.documentElement.style.setProperty('--htl-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    document.querySelectorAll('[data-htl-mega-backdrop]').forEach(backdrop => {
      backdrop.hidden = !window.matchMedia('(min-width:799px)').matches || !backdrop.closest('[data-htl-navigation]').querySelector('.htl-nav-disclosure[open]');
    });
  }
  function closeMenus(except) {
    document.querySelectorAll('[data-htl-navigation] .htl-nav-disclosure[open]').forEach(menu => {
      if (menu !== except) {
        menu.open = false;
        menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      }
    });
  }
  function closeMobile() {
    const mobile = document.querySelector('#header details[data-mobile-menu]');
    if (!mobile) return;
    if (!mobile.open) {
      document.body.classList.remove('is-active');
      mobile.querySelector('[data-mobile-menu-icon]')?.classList.remove('open');
      mobile.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      return;
    }
    if (window.mobileMenuDrawer?.el === mobile && typeof window.mobileMenuDrawer.close === 'function') {
      window.mobileMenuDrawer.close();
    }
    mobile.open = false;
    mobile.querySelector('[data-mobile-menu-icon]')?.classList.remove('open');
    document.body.classList.remove('is-active');
    mobile.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches('#header details[data-mobile-menu]')) {
      event.target.querySelector('summary')?.setAttribute('aria-expanded', String(event.target.open));
      if (!event.target.open) closeMenus();
      syncBackdrop();
      return;
    }
    if (!event.target.matches('[data-htl-navigation] .htl-nav-disclosure')) return;
    const summary = event.target.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', String(event.target.open));
    if (event.target.open) closeMenus(event.target);
    syncBackdrop();
  }, true);
  document.addEventListener('click', event => {
    clearTimeout(hoverTimer);
    const closeButton = event.target.closest('[data-htl-close-menu], [data-htl-mega-backdrop]');
    if (closeButton) {
      const current = document.querySelector('[data-htl-navigation] .htl-nav-disclosure[open]');
      closeMenus();
      syncBackdrop();
      current?.querySelector(':scope > summary')?.focus();
      return;
    }
    if (!event.target.closest('[data-htl-navigation]')) closeMenus();
    const link = event.target.closest('[data-htl-navigation] a');
    if (!link) return;
    closeMenus();
    closeMobile();
    if (link.hasAttribute('data-htl-swim-shortcut')) {
      const start = document.querySelector('[data-swim-start]');
      if (start) {
        event.preventDefault();
        start.click();
      }
    }
    const destination = new URL(link.href, window.location.href);
    if (destination.pathname === window.location.pathname && destination.hash && !link.hasAttribute('data-htl-open-finder') && !link.hasAttribute('data-htl-swim-shortcut')) {
      const target = document.getElementById(destination.hash.slice(1));
      if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
    if (typeof window.gtag === 'function') window.gtag('event', 'navigation_click', { link_text: link.textContent.trim().slice(0,100), destination: destination.pathname + destination.hash });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    clearTimeout(hoverTimer);
    const current = event.target.closest('[data-htl-navigation] .htl-nav-disclosure[open]');
    if (current) {
      current.open = false;
      current.querySelector(':scope > summary')?.focus();
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const mobile = document.querySelector('#header details[data-mobile-menu][open]');
    if (mobile) {
      closeMobile();
      mobile.querySelector('summary')?.focus();
      event.preventDefault();
    } else closeMenus();
  }, true);
  document.addEventListener('focusin', event => {
    const current = event.target.closest('[data-htl-navigation] .htl-nav-disclosure');
    closeMenus(current);
  });
  document.addEventListener('pointerover', event => {
    if (!window.matchMedia('(min-width:799px) and (hover:hover) and (pointer:fine)').matches) return;
    const menu = event.target.closest('[data-htl-navigation] .htl-nav-disclosure');
    if (!menu || menu.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => { menu.open = true; }, 180);
  });
  document.addEventListener('pointerout', event => {
    if (!window.matchMedia('(min-width:799px) and (hover:hover) and (pointer:fine)').matches) return;
    const menu = event.target.closest('[data-htl-navigation] .htl-nav-disclosure');
    if (!menu || menu.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 240);
  });
  window.addEventListener('resize', () => { clearTimeout(hoverTimer); closeMenus(); closeMobile(); syncBackdrop(); });
  window.addEventListener('scroll', syncBackdrop, { passive: true });
})();
